import { NotificationType, useTranslation } from "@next-platform/client-common-core";
import RulebookAttachFailure from "@next-platform/client-common-core/rulebook/attach/RulebookAttachFailure";
import type RulebookAttachTarget from "@next-platform/client-common-core/rulebook/attach/RulebookAttachTarget";
import { useCallback } from "react";

import useToast from "@/hooks/useToast";

/** Toasts for the attach-target picker's submit: success, character-turned-NSFW and error-code messages. */
export default function useRulebookAttachNotices() {
  const { t } = useTranslation();
  const { displayToast } = useToast();

  const notifySucceeded = useCallback(
    ({ target, isCharacterTurnedNsfw }: { target: RulebookAttachTarget; isCharacterTurnedNsfw: boolean }) => {
      displayToast({ message: t("rulebook:attach.toast.attachedTo", { name: target.name }), type: NotificationType.success });
      if (isCharacterTurnedNsfw) {
        displayToast({ message: t("rulebook:attach.toast.characterTurnedNsfw"), type: NotificationType.info });
      }
    },
    [displayToast, t],
  );

  const notifyFailed = useCallback(
    (failure: RulebookAttachFailure) => {
      if (failure === RulebookAttachFailure.NotPublicForPublicCharacter) {
        displayToast({ message: t("rulebook:attach.toast.notPublicForPublicCharacter"), type: NotificationType.error });
        return;
      }
      if (failure === RulebookAttachFailure.Unavailable) {
        displayToast({ message: t("rulebook:attach.toast.unavailable"), type: NotificationType.error });
        return;
      }
      displayToast({ message: t("rulebook:attach.toast.failed"), type: NotificationType.error });
    },
    [displayToast, t],
  );

  return { notifySucceeded, notifyFailed };
}
